/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Picker_Subtitle_TaskInputs */

const cs_templates_use_picker_subtitle_task = /** @type {(inputs: Templates_Use_Picker_Subtitle_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokol se generuje z úkolu prohlídky. Vyberte úkol níže.`)
};

const en_templates_use_picker_subtitle_task = /** @type {(inputs: Templates_Use_Picker_Subtitle_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocols are generated from a viewing task. Pick a task below.`)
};

/**
* | output |
* | --- |
* | "Protocols are generated from a viewing task. Pick a task below." |
*
* @param {Templates_Use_Picker_Subtitle_TaskInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_picker_subtitle_task = /** @type {((inputs?: Templates_Use_Picker_Subtitle_TaskInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Picker_Subtitle_TaskInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_picker_subtitle_task(inputs)
	return cs_templates_use_picker_subtitle_task(inputs)
});